// extracted by mini-css-extract-plugin
export default {"root":"Page_root__WBPEq","document":"Page_document__OpFsu","title":"Page_title__HD7W5","active":"Page_active__XmwFU"};